module.exports = __webpack_public_path__ + "img/store-c.8fa9f29.svg";